/* KALMIA — interacciones (sin librerías) */
(function () {
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.kl-reveal:not(.kl-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('kl-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('kl-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initModes(root) {
    (root || document).querySelectorAll('[data-kl-modes]').forEach(function (wrap) {
      if (wrap.dataset.klReady) return;
      wrap.dataset.klReady = '1';
      var tabs = wrap.querySelectorAll('[data-kl-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var mode = tab.getAttribute('data-kl-tab');
          wrap.setAttribute('data-mode', mode);
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          wrap.querySelectorAll('[data-kl-panel]').forEach(function (p) {
            p.hidden = p.getAttribute('data-kl-panel') !== mode;
          });
        });
      });
    });
  }

  function initBuy(root) {
    (root || document).querySelectorAll('[data-kl-buy]').forEach(function (form) {
      if (form.dataset.klReady) return;
      form.dataset.klReady = '1';
      var idInput = form.querySelector('input[name="id"]');
      form.querySelectorAll('input[data-kl-variant]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked && idInput) idInput.value = r.value; });
      });
    });
  }

  function initAll(root) { initReveal(root); initModes(root); initBuy(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
